export default "__VITE_ASSET__D4qMB1FH__"